import {inject, Injectable} from '@angular/core';
import {firstValueFrom} from 'rxjs';
import {HttpClient} from '@angular/common/http';
import {Informe, ResumenInformes} from '@kilobytelab/types';
import {API_URL_TOKEN} from '../token';

@Injectable({
  providedIn: 'root'
})
export class ApiInformesService {

  private http = inject(HttpClient);
  private apiUrl = inject(API_URL_TOKEN);

  /*** informes ***/

  getInformes(): Promise<ResumenInformes[]> {
    const url = `${this.apiUrl}informes`;
    return firstValueFrom(this.http.get<ResumenInformes[]>(url))
  }
  getInforme(id: number, curso: string, trimestre: number): Promise<Informe> {
    const url = `${this.apiUrl}informes/alumno/${id}/${curso}/${trimestre}`;
    return firstValueFrom(this.http.get<Informe>(url))
  }
  getInformesAlumno(id: number): Promise<Informe[]> {
    const url = `${this.apiUrl}informes/alumno/${id}`;
    return firstValueFrom(this.http.get<Informe[]>(url))
  }
  validarInforme(datos: {idAlumno: number, trimestre: number, curso: string}): Promise<any> {
    const url = `${this.apiUrl}informes/validar`;
    return firstValueFrom(this.http.post<any>(url, datos))
  }
  reanudarInforme(datos: {idAlumno: number, trimestre: number, curso: string}): Promise<any> {
    const url = `${this.apiUrl}informes/reanudar`;
    return firstValueFrom(this.http.post<any>(url, datos))
  }
  saveInforme(datos: Informe): Promise<any> {
    const url = `${this.apiUrl}informes`;
    return firstValueFrom(this.http.put<any>(url, datos))
  }
  eliminarInforme(id: number, trimestre: number, curso: string): Promise<any> {
    const url = `${this.apiUrl}informes/${id}/${trimestre}/${curso}`;
    return firstValueFrom(this.http.delete<any>(url))
  }

}
